import { LoadingSpinner } from "./LoadingSpinner";
import { formatMoney } from "../utils/pricing";
import "./StickyAddToCartBar.css";

type StickyAddToCartBarProps = {
  buttonLabel?: string;
  compareAtPrice: number;
  isAddingToCart: boolean;
  onAddToCart: () => void;
  onSkip?: () => void;
  price: number;
  skipLabel?: string;
  title: string;
  titleTag?: string;
  titleTags?: string[];
};

export function StickyAddToCartBar({
  buttonLabel = "In den Warenkorb",
  compareAtPrice,
  isAddingToCart,
  onAddToCart,
  onSkip,
  price,
  skipLabel,
  title,
  titleTag,
  titleTags = [],
}: StickyAddToCartBarProps) {
  const hasSkipButton = Boolean(onSkip && skipLabel);
  const hasTitleTags = titleTags.length > 0;

  return (
    <div
      className={`react-pdp__sticky-add-to-cart${
        hasSkipButton ? " react-pdp__sticky-add-to-cart--with-skip" : ""
      }`}
    >
      <div className="react-pdp__sticky-add-to-cart-wrapper">
        {hasSkipButton ? (
          <button
            className="react-pdp__sticky-skip-button"
            onClick={onSkip}
            type="button"
          >
            {skipLabel}
          </button>
        ) : null}
        <div className="react-pdp__sticky-add-to-cart-content">
          <div className="react-pdp__sticky-summary">
            <p className="react-pdp__sticky-title">
              {title}
              {titleTag && !hasTitleTags ? ` | ${titleTag}` : ""}
            </p>
            {hasTitleTags ? (
              <div className="react-pdp__sticky-title-tags">
                {titleTags.map((tag) => (
                  <span className="react-pdp__sticky-title-tag" key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
            ) : null}
            <p className="react-pdp__sticky-prices">
              {compareAtPrice > price ? (
                <span className="react-pdp__sticky-compare-price">
                  {formatMoney(compareAtPrice)}
                </span>
              ) : null}
              <span className="react-pdp__sticky-price">
                {formatMoney(price)}
              </span>
            </p>
          </div>

          <button
            className="react-pdp__sticky-button"
            disabled={isAddingToCart}
            onClick={onAddToCart}
            type="button"
          >
            {isAddingToCart ? <LoadingSpinner /> : null}
            <span>{buttonLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
